export default __webpack_public_path__ + "static/media/DevBlogsPreview.fb8637d1.PNG";